export const categoryPage = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Software Development',
  description:
    'Browse our articles dedicated to software product development and see how Boldare, as a software development company, creates business-oriented software.',
  url: 'https://www.boldare.com/categories/software-development/',
  publisher: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com/',
  },
};
